import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { DialogType, SelectOption } from '../../../@types';
import { CasinoBetsFilters } from '../../../@types/casino';
import useFilterForm from '../../../hooks/useFilterForm';
import { AdditionalQueryParams } from '../../../hooks/usePagination';
import { useCasinoProviderOptions } from '../../../hooks/useCasinoProviderOptions';
import FilterDialogLayout from '../../layouts/FilterDialogLayout';
import FormNumberInput from '../../molecules/FormNumberInput';
import FormSelect from '../../molecules/FormSelect';

type FilterCasinoBetsData = CasinoBetsFilters;

const DEFAULT_FORM_DATA: FilterCasinoBetsData = {
  roundId: undefined,
  providerName: undefined,
  gameId: undefined,
  payInAmount: undefined,
  payOutAmount: undefined,
  percentageGain: undefined,
  betStatus: undefined,
};

const BET_STATUS_OPTIONS: SelectOption[] = [
  { id: '', name: 'All bets' },
  { id: 'Won', name: 'Won' },
  { id: 'Lost', name: 'Lost' },
];

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterCasinoBets = ({ changeQuery, closeModal }: Props) => {
  const { options: providerOptions, isLoading: providersLoading } = useCasinoProviderOptions();
  const { control, handleResetFilter, handleSubmit } = useFilterForm<FilterCasinoBetsData>({
    defaultData: DEFAULT_FORM_DATA,
    changeQuery,
  });

  return (
    <FilterDialogLayout label='casino bets' onSave={handleSubmit} onClose={() => closeModal?.()} onReset={handleResetFilter}>
      <Controller
        control={control}
        name='roundId'
        render={({ field }) => <TextField {...field} value={field.value ?? ''} label='Round ID' />}
      />
      <Controller
        control={control}
        name='gameId'
        render={({ field }) => <TextField {...field} value={field.value ?? ''} label='Game ID' />}
      />
      <FormSelect
        control={control}
        name='providerName'
        label='Provider'
        options={providerOptions}
        disabled={providersLoading && !providerOptions.length}
      />
      <FormNumberInput control={control} name='payInAmount' label='Pay in amount' allowDecimals valueAsString />
      <FormNumberInput control={control} name='payOutAmount' label='Pay out amount' allowDecimals valueAsString />
      <FormNumberInput control={control} name='percentageGain' label='Percentage gain' allowDecimals valueAsString />
      <FormSelect control={control} name='betStatus' label='Bet status' options={BET_STATUS_OPTIONS} />
    </FilterDialogLayout>
  );
};

export default FilterCasinoBets;
